import { rgba } from 'polished';
import {
  sideNavBaseStyle,
  TSideNavTheme,
} from '../../base/customComponents/sideNav';
import { TStyleConfig } from '../../base/types';
import sideNavInner from '@/assets/titanbet/images/sideNav/sideNavInner.png';

export const SideNav: TStyleConfig<TSideNavTheme> = {
  baseStyle: (props) => {
    const base = sideNavBaseStyle(props);

    return {
      ...base,

      readableColor: 'beta.500',

      background: {
        width: ['100%', null, null, '270px'],
        bg: ['alpha.800', null, null, `url(${sideNavInner})`],
        bgSize: ['unset', null, null, '270px'],
        bgRepeat: ['unset', null, null, 'repeat-y'],
        borderRadius: 'lg',
        px: ['0', null, null, '9'],
        py: ['0', null, null, '4'],
        mb: ['0', null, null, '4'],
      },

      drawer: {
        ...base.drawer,
        label: 'drawer',
        gap: '1',
        maxW: ['100%', '370px', null, null],
      },
      drawerBody: {
        label: 'drawerBody',
        '> div, a': {
          ml: '0',

          '> .dropDownInner, a[class*="dropDownInner"]': {
            _first: {
              cursor: 'initial',
            },
            '&:hover, &:active': {
              bg: rgba(`${props.theme.colors.beta[500]}`, 0.8),
            },
          },
        },
        '&::-webkit-scrollbar': { display: 'none' },
      },
      icon: {
        ...base.icon,
        boxSize: '18px',
        mr: '2',
        filter: 'drop-shadow(0px 3px 4px rgba(0, 0, 0, 0.25))',
        color: 'gamma.300',
      },
      headerSX: {
        cursor: 'default',
        color: 'alpha.200',
        textTransform: 'capitalize',
        fontSize: 'sm',
        textShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
        height: '40px',
        borderBottom: '1px dashed rgba(0, 0, 0, 0.2)',
        borderTop: 'none',
        '&:hover': {
          bg: 'transparent',
        },
      },
      dropDownInner: {
        ...base.dropDownInner,
        color: 'white',
      },
      linkSX: {
        ...base.linkSX,
        borderRadius: 'none',
        mb: '0',
      },
      link: {
        ...base.link,
        pos: 'relative',
        zIndex: '5',
        textTransform: 'capitalize',
        fontSize: 'sm',
        fontWeight: 'normal',
        height: '40px',
        color: ['alpha.200', null, null, 'gamma.300'],
        fontFamily: 'accent',
        transition: 'all, 0.2s linear',
        borderTop: '1px dashed',
        borderTopColor: 'whiteAlpha.200',
        borderBottom: '1px dashed',
        borderBottomColor: 'blackAlpha.400',
        textShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',

        _first: {
          ':not(button, a[data-cy*="sideBarNavigation-My Account"])': {
            borderTop: 'none',
          },
        },
        ':last-child:not(button)': {
          borderBottom: 'none',
        },

        py: '3',
        px: ['3', null, null, '2'],
        ml: '0',

        '~ .nested': {
          pl: '0',
        },

        ':hover': {
          bg: 'blackAlpha.400',
          color: ['beta.300', null, null, 'alpha.200'],
          textShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
          svg: {
            color: ['beta.300', null, null, 'alpha.200'],
          },
        },

        ':active': {
          background: 'beta.600',
          opacity: '1',
        },

        '> .icon, .svgIcon, .dropDownIcon': {
          transition: 'all, 0.2s linear',
        },

        '.dropDownIcon': {
          color: 'gamma.300',
        },
      },

      dropDownContainerClosed: {
        '.dropDownInner': {
          px: ['3', null, null, '2'],
          borderBottom: '1px dashed rgba(0, 0, 0, 0.2)',
          borderTop: '1px dashed rgba(255, 255, 255, 0.2)',
        },

        '> a, .dropDownIcon, a': {
          color: 'gamma.300',
        },

        '&:hover, &:active': {
          '.dropDownInner': {
            label: 'dropDownInner',
            ...base.dropDownInner,
            px: ['3', null, null, '2'],
            h: '40px',
            borderTop: '1px dashed rgba(255, 255, 255, 0.2)',
            borderBottom: '1px dashed rgba(0, 0, 0, 0.2)',
          },
        },
      },
      dropDownContainerOpen: {
        ...base.dropDownContainerOpen,

        p: '0',
        h: '40px',

        '.dropDownInner': {
          px: ['3', null, null, '2'],
          color: ['gamma.300', null, null, 'alpha.200'],
          bg: ['blackAlpha.400', null, null, 'beta.800'],
          textShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
          borderBottom: [
            'none',
            null,
            null,
            '1px dashed rgba(255, 255, 255, 0.2)',
          ],
          'svg:not(.dropDownIcon)': {
            color: ['gamma.300', null, null, 'alpha.200'],
          },
        },

        '> .icon, .svgIcon, .dropDownIcon': {
          color: ['gamma.300', null, null, 'alpha.200'],
          fill: 'none',
        },
      },
    };
  },
  sizes: {},
  variants: {},
};
